<template>
  <div>
    <el-row class="title-bar">
      <el-col class="btn-group-right">
        <el-button v-if="userInfo.managerType === 'ADMIN'" size="small" @click="$refs.passwdModifyPopup.open()" type="primary" :disabled="accountModifyExecuteFlag">계정 변경 수행</el-button>
        <el-button size="small" @click="onClickExportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">  엑셀출력</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"/>
      </el-col>
    </el-row>
    <el-row>
      <el-table-wrapper ref="deviceAccountTable" :data="tableData" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;" @selection-change="handleSelectionChange"
      :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable">
        <template #obj-name-slot="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
    <w-pass-word-modify-popup ref="passwdModifyPopup" :selectedRow="multipleSelection" @close="popupResultClose"/>
  </div>
</template>

<script>
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import FileApi from '@/api/common/file';
import msgUtil from '@/utils/message';
import { mapGetters } from 'vuex';
import { isNil, isEmpty } from 'lodash';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
import WPassWordModifyPopup from './popup/PassWordModifyPopup';

export default {
  name: 'WDeviceAccountView',
  components: {
    WPassWordModifyPopup,
  },
  props: {
    activeTab: {
      type: String,
    },
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      multipleSelection: [],
      columnDefault,
      tableTotal: 0,
      tableData: [],
      accountModifyExecuteFlag: true,
      showSearchTool: false,
      columns: [
        { type: 'selection' },
        { prop: 'objName', remoteProp: 'o.obj_name', scopedSlot: 'obj-name-slot', label: '장비명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ipaddress', label: 'IP', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objtypeName', label: '장비종류', remoteProp: 'ot.objtype_name', sortable: true, searchable: true, width: 120, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objCompanyName', remoteProp: 'oc.obj_company_name', label: '제조사', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'userId', remoteProp: 'nda.user_id', label: '계정ID', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'beforePw', remoteProp: 'nda.user_pw', label: '패스워드', sortable: true, formatter: this.passwdConvert },
        { prop: 'managerId', remoteProp: 'nda.manager_id', label: '수행자', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'changeDatetime', remoteProp: 'nda.change_datetime', label: '변경일시', sortable: true, searchable: true, searchType: 'date', formatter: this.convertDatetime },
        { prop: 'elapsedDays', label: '경과일', sortable: true, formatter: this.formatElapsedDays },
      ],
      params: {
        managegroupIds: null,
      },
    };
  },
  computed: {
    ...mapGetters(['selectedObjDefineIds', 'selectedNode', 'userInfo', 'selectedObjDefineIdsForPhysical']),
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
  },
  watch: {
    selectedNode: {
      handler() {
        this.params.managegroupIds = this.selectedNode.childManagegroupIds;
        if (this.$refs.deviceAccountTable === undefined) {
          this.$nextTick(() => {
            this.$refs.deviceAccountTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
            this.loadStore();
          });
        } else {
          this.$refs.deviceAccountTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.loadStore();
        }
      },
      immediate: true,
    },
    selectedObjDefineIdsForPhysical() {
      this.loadStore();
    },
    /**
     * [activeTab 구성정보 탭 안에서 탭 선택시 store load 처리]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    activeTab: {
      handler() {
        this.loadStore();
      },
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
    /**
     * [multipleSelection 패스워드변경 팝업 - 다음 버튼 활성화/비활성화]
     * @type {Object}
     */
    multipleSelection: {
      deep: true,
      handler(value) {
        this.accountModifyExecuteFlag = isEmpty(value);
      },
    },
  },
  methods: {
    /**
     * [loadStore 그룹>장비계정 리스트 가져오기]
     * @author {Yang}
     * @return {[type]} [description]
     */
    loadStore() {
      if (this.active && this.activeTab === this.$options.name) {
        const tableParams = this.$refs.deviceAccountTable.getParameter();
        const params = {
          ...this.params,
          ...tableParams,
          treeType: this.treeType,
          managetypeId: this.selectedNode.managetypeId,
          objCompanyId: this.selectedNode.objCompanyId,
        };
        if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
          params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
        }
        if (!isEmpty(this.selectedObjDefineIds)) {
          params.objDefineIds = this.selectedObjDefineIds;
        }
        netdeviceInfoAPI
          .getNetdeviceConfigInfoDeviceAccountList(params)
          .then((result) => {
            if (result.data.success === true) {
              this.tableData = result.data.data;
              this.tableTotal = result.data.total;
            }
          });
      }
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 경과일 formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    formatElapsedDays(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : `${value}일`;
    },
    /**
     * [convertDatetime 테이블 날짜 포맷 설정]
     * @author {Yang}
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    /**
     * [onClickExportExcel 엑셀출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExportExcel() {
      const tableParams = this.$refs.deviceAccountTable.getParameter();
      delete tableParams.start;
      delete tableParams.limit;
      const params = {
        ...this.params,
        ...tableParams,
        treeType: this.treeType,
        managetypeId: this.selectedNode.managetypeId,
        objCompanyId: this.selectedNode.objCompanyId,
      };
      if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
        params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
      }
      if (!isEmpty(this.selectedObjDefineIds)) {
        params.objDefineIds = this.selectedObjDefineIds;
      }
      netdeviceInfoAPI.exportNetdeviceConfigInfoDeviceAccountList(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        });
    },
    /**
     * [handleSelectionChange 테이블 체크박스 클릭시 저장]
     * @author {Yang}
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSelectionChange(row) {
      this.multipleSelection = row;
    },
    /**
     * [passwdConvert 패스워드 컬럼 포맷터]
     * @author {Yang}
     * @return {[type]} [description]
     */
    passwdConvert() {
      return '********';
    },
    /**
     * [popupResultClose 패스워드 변경 팝업 닫기- deviceaccount 테이블 선택 제거]
     * @author {Yang}
     * @return {[type]} [description]
     */
    popupResultClose() {
      const deviceAccountTable = this.$refs.deviceAccountTable;
      deviceAccountTable.$children[0].clearSelection();
      this.loadStore();
    },
    onChangeTable() {
      this.loadStore();
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
  },
};
</script>

<style module>
.success-text {
  color: #1c53ca;
}
.failure-text {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/DeviceAccountView.vue